import { type FC, type PropsWithChildren } from "react";
import { FormattedDate, FormattedTime, type IntlShape } from "react-intl";
import styled from "styled-components";

import { options } from "./intl/DateTimeFormatOptions";

interface FormattedDateWidthDateTimeProps {
    value: Date;
    separator?: string;
    endAdornment?: string;
    variant?: "default" | "bold";
}

interface Props {
    $variant: "default" | "bold";
}

const StyledSpan = styled.span<Props>`
    font-weight: ${({ $variant }) => ($variant === "default" ? 400 : 700)};
`;
export const FormattedDateWidthDateTime: FC<PropsWithChildren<FormattedDateWidthDateTimeProps>> = ({
    value,
    separator = ", ",
    endAdornment = "",
    variant = "default",
}) => (
    <StyledSpan $variant={variant}>
        <FormattedDate value={value} {...options} />
        {separator}
        <FormattedTime value={value} />
        {endAdornment}
    </StyledSpan>
);

export function formatDateTimeAsString(value: Date | null, intl: IntlShape, separator = ", ", endAdornment = "") {
    return value ? `${intl.formatDate(value, options)}${separator}${intl.formatTime(value)}${endAdornment}` : "";
}
